import { NotificationDoc } from '@gooduncles/gu-app-schema';
import { getNotifications } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

type NotificationList = {
  unreadCount: number;
  list: NotificationDoc[];
};

const getNotificationFor = async (args: [string, string]) => {
  const [, userId] = args;
  const response = await getNotifications(
    [
      ['userId', '==', userId],
      ['isDeleted', '==', false],
    ],
    {
      sortKey: 'publishDate',
      orderBy: 'desc',
    }
  );
  const notificationList = {
    unreadCount: response.filter((noti) => noti.unread).length,
    list: response,
  };
  return notificationList;
};

/**
 * 추후 App Noti를 활성화하면 deviceId를 이용한 조회도 추가해야한다.
 */
const useNotificationForUserId = (userId?: string) => {
  const {
    data: notificationList,
    isLoading: notificationLoading,
    mutate,
  } = useSWR<NotificationList>(userId ? ['notification', userId] : null, getNotificationFor, {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });

  return {
    notificationList,
    notificationLoading,
    mutateNotificationList: mutate,
  };
};

export default useNotificationForUserId;
